import { Injectable } from '@angular/core';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ClientInfoService {

    // get

    private _isHandsetObservable: Observable<boolean> =  this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.TabletPortrait])
                                                                       .pipe(map(result => result.matches));

    private _isHandset: boolean;

    private _smallScreenSize: boolean;

    private _isIPhoneOrIPad: boolean = /iPhone|Ipad/i.test(window.navigator.userAgent) ||
                                        (window.navigator.userAgent.match(/WebKit/i) &&
                                         window.navigator.userAgent.indexOf('Android') === -1) &&
                                         !window.navigator.userAgent.match(/Windows/i);

    private _isAppleDevice: boolean = window.navigator.userAgent.match(/AppleWebKit/i) &&
                                      !window.navigator.userAgent.match(/Windows/i);

    // @ts-ignore -> window.navigator.standalone seems to not exist, but is needed to disable scrolling in ios pwa
    private _isStandalone: boolean = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

    private _isTouchDevice: boolean = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0));

    constructor(private breakpointObserver: BreakpointObserver) {
        this.breakpointObserver.observe([Breakpoints.XSmall])
            .pipe(map(result => result.matches)).subscribe(
                value => this._smallScreenSize = value.valueOf()
            );

        this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.TabletPortrait])
            .pipe(map(result => result.matches)).subscribe(
            value => this._isHandset = value.valueOf()
        );
    }

    get isHandsetObservable(): Observable<boolean> {
        return this._isHandsetObservable;
    }

    get isIPhoneOrIPad(): boolean {
        return this._isIPhoneOrIPad;
    }

    get isAppleDevice(): boolean {
        return this._isAppleDevice;
    }

    get smallScreenSize(): boolean {
        return this._smallScreenSize;
    }

    get isStandalone(): boolean {
        return this._isStandalone;
    }

    get isTouchDevice(): boolean {
        return this._isTouchDevice;
    }

    get isHandset(): boolean {
        return this._isHandset;
    }

}
